(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FixationPricingDeleteDialogController', FixationPricingDeleteDialogController);

    FixationPricingDeleteDialogController.$inject = ['$timeout', '$scope', '$uibModalInstance', 'entity', 'ToastrService', 'FixationCustomService'];

    function FixationPricingDeleteDialogController($timeout, $scope, $uibModalInstance, entity, ToastrService, FixationCustomService) {
        var vm = this;

        vm.fixation = entity;
        vm.isSaving = false;

        vm.cancel = cancel;
        vm.confirmDelete = confirmDelete;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete() {
            vm.isSaving = true;
            if (vm.fixation.id && vm.fixation.id !== null && vm.fixation.id > 0) {
                FixationCustomService.deleteFixationById( vm.fixation.id ).then( onDeleteSuccess(), onDeleteError() );
            }
        }

        function onDeleteSuccess() {
            vm.isSaving = false;
            ToastrService.success("Successfully deleted Fixation", "Success!");
            $uibModalInstance.close();
        }

        function onDeleteError() {
            vm.isSaving = false;
        }
    }
})();
